import { render, staticRenderFns } from "./AddFavorite.vue?vue&type=template&id=54d0b7bc&scoped=true&"
import script from "./AddFavorite.vue?vue&type=script&lang=js&"
export * from "./AddFavorite.vue?vue&type=script&lang=js&"
import style0 from "./AddFavorite.vue?vue&type=style&index=0&id=54d0b7bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d0b7bc",
  null
  
)

export default component.exports